import React from 'react'
import PropTypes from 'prop-types'

const ShowMoreOverlay = ({
  linesNumber,
  lineSizeUnit,
  lineHeight,
  isExpanded = false,
  children,
  setDomRef
}) => {
  const style = {
    lineHeight: `${lineHeight}${lineSizeUnit}`
  }

  if (!isExpanded) {
    style['overflow'] = 'hidden'
    style['maxHeight'] = `${linesNumber * lineHeight}${lineSizeUnit}`
  }

  return (
    <div style={style} ref={el => setDomRef(el)}>
      {children}
    </div>
  )
}

ShowMoreOverlay.propTypes = {
  lineHeight: PropTypes.number.isRequired,
  lineSizeUnit: PropTypes.string.isRequired,
  linesNumber: PropTypes.number.isRequired,
  isExpanded: PropTypes.bool
}

export default ShowMoreOverlay
